import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 w-full bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="text-gray-800 font-bold text-2xl">
         
        <img src="/images/go.jpg" alt="GoSecuNet" className="w-17 h-12 rounded-full" />
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {[
              ['/', 'Accueil'],
              ['/a-propos', 'À propos'],
              ['/services', 'Services'],
              ['/realisations', 'Réalisations'],
              ['/blog', 'Blog'],
              ['/carriere', 'Carrieres'],
              ['/contact', 'Contact'],
            ].map(([path, label]) => (
              <Link
                key={path}
                to={path}
                className={`text-base font-medium transition-colors duration-200 ${
                  isActive(path) ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600'
                }`}
              >
                {label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;












// import React from 'react';
// import { Link, useLocation } from 'react-router-dom';

// const Navbar = () => {
//   const location = useLocation();

//   const isActive = (path: string) => {
//     return location.pathname === path;
//   };

//   return (
//     <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md">
//       <div className="container mx-auto px-6">
//         <div className="flex justify-between items-center h-20">
//           <Link to="/" className="text-gray-800 font-bold text-2xl">
//             GoSecuNet
//           </Link>
          
//           <div className="hidden md:flex items-center space-x-8">
//             <Link 
//               to="/" 
//               className={`text-base font-medium ${
//                 isActive('/') ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               Accueil
//             </Link>
//             <Link 
//               to="/about" 
//               className={`text-base font-medium ${
//                 isActive('/about') ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               À propos
//             </Link>
//             <Link 
//               to="/services" 
//               className={`text-base font-medium ${
//                 isActive('/services') ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               Services
//             </Link>
//             <Link 
//               to="/realisations" 
//               className={`text-base font-medium ${
//                 isActive('/realisations') ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               Réalisations
//             </Link>
//             <Link 
//               to="/blog" 
//               className={`text-base font-medium ${
//                 isActive('/blog') ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               Blog
//             </Link>
//             <Link 
//               to="/carrieres" 
//               className={`text-base font-medium ${
//                 isActive('/carrieres') ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               Carrières
//             </Link>
//             <Link 
//               to="/contact" 
//               className={`text-base font-medium ${
//                 isActive('/contact') ? 'text-blue-600' : 'text-gray-600 hover:text-blue-600'
//               }`}
//             >
//               Contact
//             </Link>
//           </div>
//         </div>
//       </div>
//     </nav>
//   );
// };

// export default Navbar; 